import { css } from '@emotion/css';

export const getBackButtonStyles = () => ({
  button: css({ alignSelf: 'flex-start' }),
});
